import getOcTheme from '../../theme/services/getOcTheme';

const { palette, spacing, typography } = getOcTheme();

export default {
  ...typography.body1,
  '& h1': { ...typography.h1, marginTop: spacing(4), marginBottom: spacing(3) },
  '& h2': { ...typography.h2, marginTop: spacing(4), marginBottom: spacing(2) },
  '& h3': { ...typography.h3 },
  '& h4': {
    ...typography.h4,
    marginTop: spacing(3),
    marginBottom: spacing(2),
    '& code': { fontSize: '1.5rem' },
  },
  '& h5': { ...typography.h5, marginTop: spacing(2), marginBottom: spacing(1) },
  '& h6': { ...typography.h6, marginTop: spacing(1), marginBottom: spacing(1) },
  '& li p': { margin: `0 0 ${spacing(1)} 0`, wordWrap: 'break-word' },
  '& p, & li, & li p': { fontSize: 'inherit', fontWeight: 'inherit' },
  '& p': { marginBottom: spacing(2) },
  '& code, & samp, & kbd': { fontFamily: 'monospace, monospace', fontWeight: 'inherit' },
  '& strong': { color: 'inherit' },
  '& a': {
    '&, &:visited, &:hover': { color: palette.text.link },
    '&:hover': { textDecoration: 'none' },
  },
} as const;
